import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IStorage, LocalStorage } from '@isophi/core-legacy';
import { DayOffsService, PaginatedKindergartenDayOffReadList } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';

import { HelperService } from '../../../../core/services/helper.service';
import { LocalStorageConstService } from '../../../../shared/services/local-storage-const.service';

@Component({
  selector: 'app-holidays-dates',
  templateUrl: './holidays-dates.component.html',
  styleUrls: ['./holidays-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HolidaysDatesComponent {
  daysOff$: Observable<PaginatedKindergartenDayOffReadList>;

  page = 1;

  limit = 10;

  offset = 0;

  private reloadDaysOff$ = new BehaviorSubject<void>(null);

  private readonly localStorage: IStorage = new LocalStorage();

  constructor(
    private helperService: HelperService,
    private translocoService: TranslocoService,
    private dayOffsService: DayOffsService,
    private lSConstService: LocalStorageConstService
  ) {
    this.helperService.setTitle(null, this.translocoService.translate('settings/daysOff'));
    const savedLimit = this.localStorage.getItem(this.lSConstService.holidaysDatesPageLimit);
    if (savedLimit) {
      this.limit = +savedLimit;
    }
    this.daysOff$ = this.reloadDaysOff$.pipe(switchMap(() => this.dayOffsService.dayOffsList(this.limit, this.offset)));
  }

  reloadDaysOff(): void {
    this.reloadDaysOff$.next();
  }

  onPageChange(page: number): void {
    this.offset = (page - 1) * this.limit;
    this.reloadDaysOff();
  }

  onLimitChange(value: number): void {
    this.limit = value;
    this.page = 1;
    this.offset = 0;
    this.localStorage.setItem(this.lSConstService.holidaysDatesPageLimit, String(value));
    this.reloadDaysOff();
  }
}
